import { useTheme } from "@emotion/react";
import {
  Alert,
  Backdrop,
  Box,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomDatePicker from "../components/forms/CustomDatePicker";
import Form from "../components/forms/Form";
import InputComponent from "../components/forms/InputComponent";
import NavBar from "../components/NavBar";
import * as Yup from "yup";
import SubmitButton from "../components/forms/SubmitButton";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
} from "firebase/firestore";
import axios from "axios";
import { db } from "../config/firebase";
import { io } from "socket.io-client";
import { toast } from "react-toastify";
import { getAuth } from "firebase/auth";
import moment from "moment";
import { useUserAuth } from "../context/UserAuthContext";

const socket = io("https://occipital-iron-ounce.glitch.me/");

const validationSchema = Yup.object().shape({
  checkIn: Yup.date().required().label("Check In"),
  checkOut: Yup.date().required().label("Check Out"),
  guests: Yup.number("Please enter a number").required().label("Guests"),
});

const CreateReservation = () => {
  const { palette } = useTheme();

  const navigate = useNavigate();
  const room = useLocation().state.room;
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [data, setData] = React.useState({});
  const [res, setRes] = React.useState(null);
  const [reservations, setReservations] = React.useState([]);
  const [ch, setCh] = React.useState(false);
  const [checkin, setCheckin] = React.useState(null);
  const [checkout, setCheckout] = React.useState(null);
  const [guests, setGuests] = React.useState(null);
  const [user, setUser] = React.useState(null);

  const reserveRef = collection(db, "reservations");
  const userRef = collection(db, "users");

  

  socket.on("connect", () => {
    console.log("connected");

  });
  socket.on("querying", (response) => {
    setLoading(true);
    
  });

  socket.on("queried", (response) => {
    setRes(response);
    console.log("final")
  });

  async function addReservation() {
    const reservationsDoc = await collection(db, "reservations");
    const reservation = {
      room: room,
      checkIn: moment(checkin).format("YYYY-MM-DD"),
      checkOut: moment(checkout).format("YYYY-MM-DD"),
      guests: guests,
      status: "paid",
      user: user,
      price: room.price * moment(checkout).diff(moment(checkin), "days"),
    };
    const docRef = await addDoc(reservationsDoc, reservation);
    console.log(docRef);
    if (docRef) {
      toast.success("Reservation created successfully");
      navigate("/reservations");
      setLoading(false);
    }
  }



  React.useEffect(() => {
    if (res && res === "Request cancelled by user") {
      setRes(null);
      toast.error("Request cancelled by user");
    }
     if (res === "The service request is processed successfully.") {
       addReservation();
       alert("The service request is processed successfully.");
     }

    //get room data
    async function fetchData() {
      setLoading(true);
      try {
        const roomsDoc = await doc(db, "rooms", room.id);
        const rm = await getDoc(roomsDoc);
        setData(rm.data());
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error.message);
      }
    }
    if (res === "The initiator information is invalid.") {
      toast.error("The initiator information is invalid.");
    }

    //get all reservations
    async function fetchReservations() {
      setLoading(true);
      try {
        const reservationsDoc = await collection(db, "reservations");
        const reservations = await getDocs(reservationsDoc);
        setReservations(
          reservations.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error.message);
      }
    }
   
    async function fetchUser() {
      setLoading(true);
      try {
        const userDoc = await doc(db, "users", getAuth().currentUser.uid);
        const user = await getDoc(userDoc);
        setUser(user.data());
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error.message);
      }
    }

    fetchData();
    fetchReservations();
    fetchUser();

  }, [res, room.id, navigate]);
  // find

  const handleSubmit = async ({ checkIn, checkOut, guests }) => {
    setLoading(true);
    setError(null);
    //check if checkin and checkout are not similar to those in the room

    const isResrved = reservations.find(
      (res) =>
        moment(res.checkIn).isSame(moment(checkIn), "day") &&
        moment(res.checkOut).isSame(moment(checkOut), "day")
    );
    if (isResrved) {
      setLoading(false);
      toast.error("Room is already reserved on this dates. Please try again");
      return;
    }
    //check if checkin and checkout are not similar to those in the room
    if (moment(checkIn).isSame(moment(checkOut), "day")) {
      setLoading(false);
      toast.error("Check in and check out dates are the same");
      return;
    }
    setCheckin(checkIn);
    setCheckout(checkOut);
    setGuests(guests);

    const qer = await axios.get("https://occipital-iron-ounce.glitch.me/mpesa");
    setLoading(false);
  };

  return (
    <>
      <NavBar />
      <Box
        sx={{
          mt: 5,
        }}
      >
        <Grid container spacing={3}>
          <Container maxWidth="lg">
            <Grid item md={12}>
              <Typography
                component="h2"
                variant="div"
                sx={{
                  textAlign: "center",
                  fontSize: "3rem",
                  fontWeight: "bold",
                  fontFamily: "heading",
                  color: palette.primary.main,
                  mb: 5,
                }}
              >
                Create Reservation
              </Typography>
            </Grid>
            {loading && (
              <Backdrop open={loading} style={{ zIndex: "1" }}>
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
            {error && <Alert severity="error">{error}</Alert>}
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Card
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <Typography
                    component="header"
                    variant="div"
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Room Details
                  </Typography>
                  <CardMedia src={room.image} />
                  <CardContent>
                    <Typography component="header" variant="div">
                      Room: {room.name}
                    </Typography>
                    <Typography component="header" variant="div">
                      Price: {room.price}
                    </Typography>
                    <Typography component="body" variant="div">
                      Features: {room.features}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6}>
                <Form
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                  initialValues={{
                    checkIn: "",
                    checkOut: "",
                    guests: "",
                  }}
                >
                  <Grid
                    sx={{
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    container
                    spacing={2}
                  >
                    <Grid item md={6}>
                      <CustomDatePicker label="checkIn" required />
                    </Grid>
                    <Grid item md={6}>
                      <CustomDatePicker label="checkOut" required />
                    </Grid>
                    <Grid item md={6}>
                      <InputComponent label="guests" type="number" required />
                    </Grid>
                    <Grid item md={6}>
                      <SubmitButton title={"Pay now to book"} />
                    </Grid>
                  </Grid>
                </Form>
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Box>
    </>
  );
};

export default CreateReservation;
